import React, { useCallback, useEffect } from 'react'
import { func } from 'prop-types'
import { useOverlay } from '@fs/zion-ui'
import { trackEvent } from '@fs/zion-analytics'
import CustomCreateGroupOverlay from '../CreateGroupOverlay/CustomCreateGroupOverlay'
import ButtonCard from './ButtonCard'

const cardContentProps = {
  headingFallback: 'Allow family to see your stories!',
  headingKey: 'familygroups.card.createGroup.heading',
  buttonFallback: 'Create Group',
  buttonKey: 'create-edit-group.action.create-group',
  descriptionFallback: "Create a family group to share your life's most impactful stories with your loved ones.",
  descriptionKey: 'familygroups.card.createGroup.description',
}

export default function CreateGroupCard({ refreshGroups }) {
  const createGroupOverlay = useOverlay()

  useEffect(() => {
    if (!createGroupOverlay.isOpen && createGroupOverlay?.transitioning) {
      refreshGroups()
    }
  }, [createGroupOverlay, refreshGroups])

  const onClick = useCallback(() => {
    trackEvent({ event_name: 'CreateGroupCard:CREATE_GROUP:CLICK' })
    createGroupOverlay.handleClick()
  }, [createGroupOverlay])

  return (
    <ButtonCard buttonProps={{ onClick }} {...cardContentProps}>
      <CustomCreateGroupOverlay redirectOnCreate={false} overlay={createGroupOverlay} />
    </ButtonCard>
  )
}

CreateGroupCard.propTypes = {
  refreshGroups: func.isRequired,
}
